import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      padding: '1.4rem',
      marginBottom: '0.5rem'
    },
    headerTitle: {
      height: '40px',
      marginBottom: '0.5rem'
    },
    headerSubtitle: {
      height: '20px'
    }
  },

  selectorControls: {
    height: '40px',
    marginBottom: '0.5rem'
  },
  carousel: {
    main: {
      height: '260px'
    },
    box: {},
    body: { padding: '1.0rem', height: '100px' },
    image: {
      height: '140px',
      marginBottom: '0.5rem'
    },
    title: {
      height: '20px',
      marginBottom: '1rem'
    },
    subtitle: {
      height: '20px'
    },
    button: {
      height: '40px',
      float: 'right'
    }
  },

  centerElement: {
    marginLeft: '25%'
  },
  dots: {
    height: '20px',
    marginBottom: '0.25rem'
  },
  disclaimer: {
    height: '20px',
    marginTop: '0.25rem'
  }
};

const SkeletonBreakingDealsMobile = (props) => {
  const [className, style] = useStyles(props);
  const {
    header,
    selectorControls,
    accordionHeading,
    subtitle,
    carousel,
    centerElement,
    dots,
    disclaimer
  } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonFaresCarouselBackgroundImageMobile"
    >
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={header.main}>
            <Col xs="12" className="fr-skeleton-element" style={header.headerTitle} />
            <Col xs="10" className="fr-skeleton-element" style={header.headerSubtitle} />
          </Box>
        </Col>
      </Row>

      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={selectorControls}></Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={accordionHeading} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Col xs="10" className="fr-skeleton-element" style={subtitle} />
        </Col>
      </Row>
      <Row gutters>
        <Col style={carousel.main}>
          <Box className="fr-skeleton-box fr-clearfix" style={carousel.box}>
            <Col xs="12" className="fr-skeleton-element" style={carousel.image} />
            <Box className="fr-skeleton-box " style={carousel.body}>
              <Col xs="6" className="fr-skeleton-element" style={carousel.title} />
              <Col xs="4" className="fr-skeleton-element" style={carousel.button} />
            </Box>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="6" style={centerElement}>
          <Box className="fr-skeleton-element" style={dots} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="12">
          <Box className="fr-skeleton-element" style={disclaimer} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonBreakingDealsMobile.componentName = 'SkeletonBreakingDealsMobile';

export default SkeletonBreakingDealsMobile;
